import { createSelector } from 'reselect';
import { purchasedTimesSRPSelector } from 'selectors/testTarget/offers/purchasedTimesSRP/purchasedTimesSRPSelector';

const showSelector = createSelector(purchasedTimesSRPSelector, purchasedTimesSRP => !!purchasedTimesSRP.show);

export { showSelector };
